import { render, staticRenderFns } from "./AcademicPayments.vue?vue&type=template&id=c8a77020&scoped=true"
import script from "./AcademicPayments.vue?vue&type=script&lang=js"
export * from "./AcademicPayments.vue?vue&type=script&lang=js"
import style0 from "./AcademicPayments.vue?vue&type=style&index=0&id=c8a77020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a77020",
  null
  
)

export default component.exports